import { useAuth } from '@/context/AuthContext'
import { useApp } from '@/hooks/useApp'
import { Add } from '@/icons'
import { Box, useDisclosure } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import { MenuItem } from './MenuItem'

export const NewInsuranceButtonChaloupka = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { setProduct, app } = useApp()
  const { user } = useAuth()
  let closeTimeout: NodeJS.Timeout

  return (
    <Box
      sx={{ position: 'relative' }}
      onMouseEnter={() => {
        if (!user?.liabilityRights)
          return

        clearTimeout(closeTimeout)
        onOpen()
      }}
      onMouseLeave={() => {
        closeTimeout = setTimeout(() => onClose(), 300)
      }}
    >
      <MenuItem
        variant="solid"
        colorScheme="primary"
        onClick={() => setProduct(Product.PropertyInsurance)}
        to={`/${app}/wizard/1?new`}
      >
        <Add />
        Nové pojištění
      </MenuItem>

      {isOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: '100%',
            pt: 2,
            w: 'max-content',
          }}
        >
          <MenuItem
            variant="outline"
            colorScheme="gray"
            to={`/${app}/wizard/1?new`}
            onClick={() => setProduct(Product.LiabilityInsurance)}
            sx={{ boxShadow: 'md' }}
          >
            <Add color="secondary.500" />
            Pojištění odpovědnosti
          </MenuItem>
        </Box>
      )}
    </Box>
  )
}